import { ConfirmDialog, LinearProgress, Typography } from '@occc/ui-design-system';

type RetailerNetworkLocationGroupRemoveLocationDialogProps = {
  open: boolean;
  setOpen: (value: boolean) => void;
  onConfirm: () => void;
  loading?: boolean;
};

export const RetailerNetworkLocationGroupRemoveLocationDialog = ({
  open,
  setOpen,
  onConfirm,
  loading,
}: RetailerNetworkLocationGroupRemoveLocationDialogProps) => (
  <ConfirmDialog
    dialogTitle='Remove Location from Location Group'
    confirmButtonText='Remove'
    open={open}
    onClose={() => setOpen(false)}
    confirmButtonProps={{
      onClick: onConfirm,
      color: 'error',
      disabled: loading,
    }}
  >
    {loading && <LinearProgress />}

    <Typography>
      Are you sure you would like to remove this Location from the Location Group? This will not
      delete the location, only remove it from the Location Group.
    </Typography>
  </ConfirmDialog>
);
